import axiosInstance from "utils/AxiosInterceptor";

import { GetAllReportResponse } from "interfaces/Response/GetAllReportResponse";
import { Report } from "interfaces/Models";
import {
  SendAnswerFeedbackRequest,
  UpdateStatusReportPartiallyWrongRequest,
  UpdateStatusReportRequest,
} from "interfaces";

export const getAllReports = async (...args: any) => {
  let url = `api/projects/get-all-reports?`;

  args.forEach((x: any) => {
    if (x) {
      for (const [key, value] of Object.entries(x)) {
        if (value !== null && value !== "") url = url + `&${key}=${value}`;
      }
    }
  });
  return axiosInstance.get<GetAllReportResponse>(url);
};

export const getDetailReport = async (reportId: string) => {
  return axiosInstance.get<Report>(`api/projects/report?id=${reportId}`);
};

export const updateStatusReport = async (
  payload: UpdateStatusReportRequest
) => {
  return axiosInstance.put("api/projects/report", payload);
};

export const updateStatusReportPartiallyWrong = async (
  payload: UpdateStatusReportPartiallyWrongRequest
) => {
  return axiosInstance.put("api/projects/report-answer", payload);
};

export const reportAnswer = async (payload: SendAnswerFeedbackRequest) => {
  return axiosInstance.post("api/projects/report", payload);
};

export const checkOpenedReport = async () => {
  return axiosInstance.get("api/projects/check-report");
};
